import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { MpaNavigationMasterPageConfig } from '../types'
import { name } from '../symbols'

const mpaNavigationMasterPageConfig: MasterPageConfigFn<MpaNavigationMasterPageConfig> = ({ api }: VsmContext) => {
	const transitionName = api.page.getPageTransition()
	const hasPageTransition = transitionName !== null && transitionName !== 'none'

	return {
		hasPageTransition,
	}
}

export const masterPageConfig: MasterPageConfigEntry<MpaNavigationMasterPageConfig> = {
	name,
	configFactory: mpaNavigationMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmMpaNavigationMasterPageConfig',
}
